/*
 * @Author: Yun 
 * @Date: 2025-09-24 15:35:47 
 * @Last Modified by: Yun.WU
 * @Last Modified time: 2026-05-15 17:01:53
 */

import React, { useEffect, useState, useCallback } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import NavBar from '@components/NavBar';
import Hero from '@components/Hero';
import TimeLine from '@components/TimeLine';
import HighLight from '@components/HighLight';
import RightPath from '@components/RightPath';
import ProductCollection from '@components/ProductCollection';
/* import Showcase from '@components/Showcase';
import StatisticsBoard from '@components/StatisticsBoard';
import MagneticCards from '@components/MagneticCards';
import PhotoFlow from '@components/PhotoFlow';
import SmartReader from '@/components/SmartReader';
import SpotlightGallery from '@components/SpotlightGallery'; */
import Loader from '@components/Loader';
import { setupWxShare } from '@utils/wxShare';
import { content } from '@configs/content';

import './App.scss';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, useGSAP);

function App() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // 微信分享
        setupWxShare({
            title: content.app.wxShare.title,
            desc: content.app.wxShare.desc,
            imgUrl: content.app.wxShare.getImgUrl(),
        });
    }, []);

    // 只在资源加载完成后创建ScrollSmoother
    useGSAP(() => {
        if (!isLoaded) return;

        // 延迟初始化ScrollSmoother，确保Hero动画能正常播放
        const timer = setTimeout(() => {
            ScrollSmoother.create({
                wrapper: '#smooth-wrapper',
                content: '#smooth-content', 
                smooth: 0.1,
                effects: true,
                smoothTouch: 0.1,
                normalizeScroll: true,
                ignoreMobileResize: true,
            });
        }, 100);

        return () => clearTimeout(timer);
    }, [isLoaded]);

    // 处理加载完成 - 使用useCallback避免函数重新创建导致useEffect重复执行
    const handleLoadComplete = useCallback(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div className="app">
            {/* 加载器 - 始终渲染，自己控制显示隐藏 */}
            <Loader 
                onLoadComplete={handleLoadComplete}
                debugMode={process.env.NODE_ENV === 'development'}
            />

            {/* 主内容 - 只在加载完成后渲染 */}
            {isLoaded && (
                <>
                    {/* 导航栏 */}
                    <NavBar />
                    
                    <div className="app__pc" id="smooth-wrapper">
                        <div id="smooth-content">
                            <Hero />
                            <HighLight />
                            <TimeLine />
                            <RightPath />
                            <ProductCollection />
                            {/* <Showcase />  */}
                            {/* <StatisticsBoard /> */}
                            {/* <MagneticCards /> */}
                            {/* <PhotoFlow /> */}
                            {/* <SmartReader />  */}
                            {/* <SpotlightGallery /> */}
                            
                            {/* 测试用的padding，方便看到各组件滑走效果 */}
                            {/* <div style={{height: '200vh', background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '2rem'}}>
                                <div style={{textAlign: 'center'}}>
                                    <h2>测试区域</h2>
                                    <p>切勿截图</p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </>
             )}
        </div>
    );
}

export default App;
